// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ddcdbb093382a9292fe5","453":"f9de8dab6d9ec02e4b0e"}[chunkId] + ".js";
};